// extracted by mini-css-extract-plugin
export default {"container":"Privacy_container__lsHUp","content":"Privacy_content__PH-fg","title":"Privacy_title__ouKnX","date":"Privacy_date__I0YaJ"};